import { FormControl } from '@angular/forms';
import { BlobLocation } from '../../blob/blob.interfaces';

export class BlobLocationFormControl extends FormControl<BlobLocation | null> {
  override patchValue(
    value: BlobLocation | string | null,
    options?: {
      onlySelf?: boolean;
      emitEvent?: boolean;
      emitModelToViewChange?: boolean;
      emitViewToModelChange?: boolean;
    },
  ) {
    if (typeof value === 'string') {
      // If the patched value is a string, it's simply the blob URL API response,
      // we switch it out for 'undefined' so that we don't PATCH it to the
      // backend again, which expects BlobLocation's on PATCH, not string.
      value = undefined as unknown as BlobLocation;
    }
    super.patchValue(value, options);
  }
}
